import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const user = { 
    firstName: "Sadia",
    email: "sadia@example.com",
    role: "user"
  };

  const stats = {
    totalOrders: 12,
    totalFollowers: 5400,
    totalSpent: 120,
    pendingOrders: 2
  };

  const orders = [
    {
      _id: 1,
      orderNumber: "ORD-101",
      platform: "instagram",
      followersCount: 1000,
      status: "completed",
      price: 20,
      paymentMethod: "JazzCash",
      date: "2024-01-15",
      deliveryDate: "2024-01-17"
    },
    {
      _id: 2,
      orderNumber: "ORD-102",
      platform: "facebook",
      followersCount: 500,
      status: "pending",
      price: 10,
      paymentMethod: "Bank Account",
      date: "2024-01-10",
      deliveryDate: "Expected: 2024-01-12"
    },
    {
      _id: 3,
      orderNumber: "ORD-103",
      platform: "twitter",
      followersCount: 750,
      status: "processing",
      price: 15,
      paymentMethod: "PayPal",
      date: "2024-01-08",
      deliveryDate: "Expected: 2024-01-10"
    }
  ];

  const paymentMethods = [
    { name: "JazzCash", icon: "Mobile Wallet", available: true },
    { name: "Bank Account", icon: "Bank Transfer", available: true },
    { name: "PayPal", icon: "Online Payment", available: true }
  ];

  const handleDeleteAccount = async () => {
    setDeleteLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      alert('Account deleted successfully!');
      window.location.href = '/login';
    } catch (error) {
      alert('Failed to delete account. Please try again.');
    } finally {
      setDeleteLoading(false);
      setShowDeleteModal(false);
    }
  };

  const downloadReceipt = (order) => {
    const receiptData = {
      receiptNumber: `REC-${order.orderNumber}`,
      orderNumber: order.orderNumber,
      customerName: user.firstName,
      customerEmail: user.email,
      platform: order.platform,
      followersCount: order.followersCount,
      price: order.price,
      paymentMethod: order.paymentMethod,
      orderDate: order.date,
      deliveryDate: order.deliveryDate,
      status: order.status
    };

    const receiptContent = `
========================================
           RECEIPT
========================================

Receipt Number: ${receiptData.receiptNumber}
Order Number: ${receiptData.orderNumber}
Date: ${receiptData.orderDate}

Customer Information:
Name: ${receiptData.customerName}
Email: ${receiptData.customerEmail}

Order Details:
Platform: ${receiptData.platform}
Followers: ${receiptData.followersCount}
Price: $${receiptData.price}
Payment Method: ${receiptData.paymentMethod}

Status: ${receiptData.status}
Delivery Date: ${receiptData.deliveryDate}

========================================
           Thank You!
========================================
    `;

    const blob = new Blob([receiptContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${receiptData.receiptNumber}.txt`;
    a.click();
    window.URL.revokeObjectURL(url);
    
    alert('Receipt downloaded successfully!');
  };

  const downloadOrderHistory = () => {
    const csvContent = "Order Number,Platform,Followers,Price,Status,Payment Method,Date,Delivery Date\n" +
      orders.map(order => `${order.orderNumber},${order.platform},${order.followersCount},${order.price},${order.status},${order.paymentMethod},${order.date},${order.deliveryDate}`).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'order_history.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    
    alert('Order history downloaded successfully!');
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'completed': return 'bg-green-100 text-green-600';
      case 'pending': return 'bg-yellow-100 text-yellow-600';
      case 'processing': return 'bg-blue-100 text-blue-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900">
            Welcome back, <span className="text-purple-600">{user.firstName}</span> 
          </h1>
          <p className="text-white mt-2">
            Track your orders and manage your account
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="border-b border-gray-300 mb-8">
          <nav className="-mb-px flex space-x-8">
            {['overview', 'orders', 'payments', 'profile'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`py-2 px-1 border-b-2 font-medium text-sm capitalize transition-all duration-300 ${
                  activeTab === tab
                    ? 'border-purple-600 text-purple-600 bg-purple-50'
                    : 'border-transparent text-gray-600 hover:text-purple-600 hover:border-purple-600'
                }`}
              >
                {tab}
              </button>
            ))}
          </nav>
        </div>

        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="space-y-8">
            {/* Stats */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="card premium-glow">
                <p className="text-white text-sm">Total Spent</p>
                <h2 className="text-3xl font-bold mt-2 text-white">${stats.totalSpent}</h2>
              </div>
              <div className="card premium-glow">
                <p className="text-white text-sm">Followers</p>
                <h2 className="text-3xl font-bold mt-2 text-purple-600">
                  {stats.totalFollowers.toLocaleString()}
                </h2>
              </div>
              <div className="card premium-glow">
                <p className="text-white text-sm">Total Spent</p>
                <h2 className="text-3xl font-bold mt-2 text-white">
                  ${stats.totalSpent}
                </h2>
              </div>
              <div className="card premium-glow">
                <p className="text-white text-sm">Pending</p>
                <h2 className="text-3xl font-bold mt-2 text-orange-600">
                  {stats.pendingOrders}
                </h2>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2 card premium-glow">
                <h2 className="text-xl font-semibold mb-4 text-white">Recent Orders</h2>
                <div className="space-y-4">
                  {orders.slice(0, 3).map((order) => (
                    <div key={order._id} className="flex items-center justify-between p-4 bg-premium-purple-200 rounded-lg hover:bg-premium-purple-300 transition-all duration-300 border border-premium-purple-600">
                      <div>
                        <p className="font-medium text-white">{order.orderNumber}</p>
                        <p className="text-sm text-white">{order.platform} - {order.followersCount} followers</p>
                      </div>
                      <div className="text-right">
                        <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(order.status)}`}>
                          {order.status}
                        </span>
                        <p className="text-sm font-medium mt-1 text-white">${order.price}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={() => setActiveTab('orders')} className="block w-full text-center mt-4 text-white hover:text-purple-200 transition-colors duration-300">
                  View All Orders
                </button>
              </div>

              <div className="card premium-glow">
                <h2 className="text-xl font-semibold mb-4 text-white">Quick Actions</h2>
                <div className="space-y-3">
                  <Link to="/packages" className="block text-center btn-primary">
                    Buy Followers
                  </Link>
                  <Link to="/profile" className="block btn-secondary text-center">
                    Update Profile
                  </Link>
                  <button onClick={() => setShowDeleteModal(true)} className="w-full btn-outline text-center">
                    Delete Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Orders Tab */}
        {activeTab === 'orders' && (
          <div className="card premium-glow">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold mb-4 text-white">Order History</h2>
              <button onClick={downloadOrderHistory} className="btn-secondary text-white">
                Download All Orders
              </button>
            </div>
            
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-white border-b border-gray-300">
                    <th className="py-3 text-gray-300">Order</th>
                    <th className="text-gray-300">Platform</th>
                    <th className="text-gray-300">Followers</th>
                    <th className="text-gray-300">Price</th>
                    <th className="text-gray-300">Payment</th>
                    <th className="text-gray-300">Status</th>
                    <th className="text-gray-300">Date</th>
                    <th className="text-gray-300">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order._id} className="border-b border-premium-purple-700 hover:bg-premium-purple-200 transition-all duration-300">
                      <td className="py-3 font-medium text-white">{order.orderNumber}</td>
                      <td className="capitalize text-white">{order.platform}</td>
                      <td className="text-white">{order.followersCount}</td>
                      <td className="text-white">${order.price}</td>
                      <td className="text-white">{order.paymentMethod}</td>
                      <td>
                        <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(order.status)}`}>
                          {order.status}
                        </span>
                      </td>
                      <td className="text-white">{order.date}</td>
                      <td>
                        <button 
                          onClick={() => downloadReceipt(order)}
                          className="text-white hover:text-light-purple-200 text-sm transition-colors duration-300"
                        >
                          Download Receipt
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Payments Tab */}
        {activeTab === 'payments' && (
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="card premium-glow">
              <h2 className="text-xl font-semibold mb-4 text-white">Payment Methods</h2>
              <div className="space-y-4">
                {paymentMethods.map((method, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-premium-purple-200 rounded-lg border border-premium-purple-600">
                    <div>
                      <p className="font-medium text-white">{method.name}</p>
                      <p className="text-sm text-white">{method.icon}</p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs ${
                      method.available ? 'bg-green-700 text-green-300' : 'bg-gray-600 text-gray-400'
                    }`}>
                      {method.available ? 'Available' : 'Unavailable'}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="card premium-glow">
              <h2 className="text-xl font-semibold mb-4 text-white">Payment Summary</h2>
              <div className="space-y-4">
                <div className="flex justify-between">
                  <span className="text-white">Total Spent</span>
                  <span className="font-semibold text-white">${stats.totalSpent}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Total Orders</span>
                  <span className="font-semibold text-white">{stats.totalOrders}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Average Order Value</span>
                  <span className="font-semibold text-white">${(stats.totalSpent / stats.totalOrders).toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Profile Tab */}
        {activeTab === 'profile' && (
          <div className="card premium-glow">
            <h2 className="text-xl font-semibold mb-4 text-white">Profile Management</h2>
            <div className="grid lg:grid-cols-2 gap-8">
              <div>
                <h3 className="font-medium mb-4 text-white">Account Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-sm text-gray-300">Name</label>
                    <p className="font-medium text-white">{user.firstName}</p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-300">Email</label>
                    <p className="font-medium text-white">{user.email}</p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-300">Account Type</label>
                    <p className="font-medium capitalize text-white">{user.role}</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="font-medium mb-4 text-white">Quick Actions</h3>
                <div className="space-y-3">
                  <Link to="/profile" className="block btn-secondary text-center">
                    Edit Profile
                  </Link>
                  <button onClick={() => setShowDeleteModal(true)} className="w-full btn-outline text-white">
                    Delete Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Account Modal */}
        {showDeleteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div className="bg-premium-purple-100 rounded-lg p-8 max-w-md w-full mx-4 premium-glow-strong border border-premium-purple-600">
              <h3 className="text-xl font-semibold mb-4 text-red-600">Delete Account</h3>
              <div className="mb-6">
                <p className="text-white mb-4">
                  Are you sure you want to delete your Account? This action cannot be undone.
                </p>
                <div className="bg-red-100 border border-red-600 rounded p-4">
                  <p className="text-sm text-red-600">
                    <strong>Warning:</strong> Deleting your Account will:
                  </p>
                  <ul className="text-sm text-red-600 mt-2 list-disc list-inside">
                    <li>Permanently delete All your data</li>
                    <li>Cancel all active orders</li>
                    <li>Remove your profile information</li>
                    <li>You won't be able to recover this Account</li>
                  </ul>
                </div>
              </div>
              <div className="flex gap-4">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="flex-1 btn-secondary text-gray-900"
                  disabled={deleteLoading}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDeleteAccount}
                  className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={deleteLoading}
                >
                  {deleteLoading ? 'Deleting...' : 'Delete Account'}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Dashboard;